
document.addEventListener('DOMContentLoaded', function() {
  var qEl = document.getElementById('math_question');
  var aEl = document.getElementById('math_answer');
  var cartForm = document.querySelector('form[action^="/cart"]');
  if (!qEl || !aEl || !cartForm) return;


  var n1 = Math.ceil(Math.random() * 10);
  var n2 = Math.ceil(Math.random() * 10);


  qEl.textContent = n1 + ' + ' + n2;


  cartForm.addEventListener('submit', function(e) {
    if (parseInt(aEl.value, 10) !== n1 + n2) {
      e.preventDefault();
      aEl.style.boxShadow = '0 0 5px red';
      aEl.focus();
    }
  });
});



